var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13L9.784 13.6981L10.5 14.4325L11.216 13.6981L10.5 13ZM11.5 0.999998C11.5 0.447713 11.0523 -1.59908e-06 10.5 -1.62322e-06C9.94772 -1.64737e-06 9.5 0.447713 9.5 0.999998L11.5 0.999998ZM3.284 7.03143L9.784 13.6981L11.216 12.3019L4.716 5.63523L3.284 7.03143ZM11.216 13.6981L17.716 7.03143L16.284 5.63523L9.784 12.3019L11.216 13.6981ZM11.5 13L11.5 0.999998L9.5 0.999998L9.5 13L11.5 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16L1 17.3333C1 18.8061 2.21523 20 3.71429 20L17.2857 20C18.7848 20 20 18.8061 20 17.3333V16",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/Import.b9cdbe1c926aa6c02f5ba7f51fb3a110.svg";
export { ForwardRef as ReactComponent };